import React from 'react';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';

const Footer = () => {

  return (
    <footer className="footer">
      <div className="footer__copyright">
        <NeuroMessage id="footer.copyright" tagName='p'/>
        <img src="/classpath/assets/images/logo-equal-housing-horiz.svg" />
      </div>

      <div className="decoration bottom">
        <div className="circle blue"></div>
        <div className="circle yellow"></div>
      </div>
      
    </footer>
  );
};

export default Footer;
